import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexPage from '../views/index.vue'
import paymentRoutes from './payment'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexPage
  },
  {
    path: '/store',
    name: 'store',
    component: () => import('@/views/store.vue')
  },
  {
    path: '/redeem',
    name: 'redeem-index',
    component: () => import('@/views/redeem/index.vue')
  },
  {
    path: '/redeem/channel/:id',
    name: 'redeem-serial-number',
    component: () => import('@/views/redeem/detail.vue')
  },
  {
    path: '/redeem/sugoi-result',
    name: 'redeem-sugoi-result',
    component: () => import('@/views/redeem/sugoiResult.vue')
  },
  {
    path: '/redeem/inProgress',
    name: 'redeem-inprogress',
    component: () => import('@/views/redeem/loading.vue')
  },
  ...paymentRoutes,
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/layout/error.vue')
  },
  {
    path: '/success/:type',
    name: 'success',
    component: () => import('@/views/layout/success.vue')
  },
  { 
    path: "*",
    name: 'page-not-found',
    component: () => import('@/views/layout/pageNotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  /**
   * 
   * @returns https://router.vuejs.org/zh/guide/advanced/scroll-behavior.html
   * @param to
   * @param from
   * @param savedPosition
   */
  scrollBehavior: () => {
    return { x: 0, y: 0 } // 始终滚动到顶部
  },
  routes,
})

router.beforeEach((to, from, next) => {
  // fix ios old version sdk invalid token issue
  if (to?.query?.token && to.query.token.indexOf('?') !== -1) {
    const { token: _token, ...otherQuery } = to.query
    const replaceQuery = 'token=' + String(_token).replaceAll('?', '&')
    next({
      path: from.fullPath + '?' + replaceQuery,
      replace: true,
      query: otherQuery
    })
  }

  next()
})

export default router